import { render, staticRenderFns } from "./RecordDetailDialog.vue?vue&type=template&id=554951c0&scoped=true"
import script from "./RecordDetailDialog.vue?vue&type=script&lang=js"
export * from "./RecordDetailDialog.vue?vue&type=script&lang=js"
import style0 from "./RecordDetailDialog.vue?vue&type=style&index=0&id=554951c0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "554951c0",
  null
  
)

export default component.exports